/* eslint-disable */
import Vue from 'vue';
import { getAqiFontColor, getAqiLevel } from './pollutionLevel'
import { Toast } from 'vant';

let vue = new Vue();

class Common {
    constructor() {
        this.getAqiLevel = getAqiLevel
        this.getAqiFontColor = getAqiFontColor
        // ⁰¹²³⁴⁵⁶⁷⁸⁹⁺⁻⁼⁽⁾ 上标
        // ₀₁₂₃₄₅₆₇₈₉₊₋₌₍₎ 下标
        this.DAY = 1000 * 60 * 60 * 24;
        this.WEEK = this.DAY * 7;

        this.colors = [
            'rgb(120,205,0)',
            'rgb(254,218,30)',
            'rgb(247,138,0)',
            'rgb(216,29,29)',
            'rgb(146,2,86)',
            'rgb(96,0,28)',
        ];

        this.aqiColorArr = [
            '#3FD271',
            '#FFC517',
            '#FF8A2E',
            '#FC3939',
            '#D31468',
            '#AF0522',
            '#D8D9D9',
            '#588DFF' // 风，能见度颜色
        ]

        this.aqiShadowArr = [
            'rgba(63, 210, 113, 0.35)',
            'rgba(255, 197, 23, 0.35)',
            'rgba(255, 138, 46, 0.35)',
            'rgba(252, 57, 57, 0.35)',
            'rgba(211, 20, 104, 0.35)',
            'rgba(175, 5, 34, 0.35)',
            'rgba(216, 217, 217, 0.35)'
        ]
    }

    // 获取URL参数
    getUrlParams() {
        let paramStr = window.location.search;
        if (paramStr.indexOf('?') > -1) {
            paramStr = paramStr.slice(1);
            let paramArry = paramStr.split('&');
            let params = {};
            for (let param of paramArry) {
                param = param.split('=');
                params[param[0]] = param[1];
            }
            this.params = params;
            return params;
        } else {
            return {};
        }
    }

    // 计算总页数
    getTotalPage(count = 0, pageSize = 1) {
        let totalPage;
        if (count % pageSize === 0) {
            totalPage = count / pageSize;
        } else {
            totalPage = parseInt(count / pageSize) + 1;
        }
        return totalPage;
    }

    // 获取格式化时间
    getFormatDate(date, type = 0) {
        if (!(date instanceof Date)) {
            date = new Date(date);
        }
        let year = this.formatNum(date.getFullYear());
        let month = this.formatNum(date.getMonth() + 1);
        let day = this.formatNum(date.getDate());
        let hour = this.formatNum(date.getHours());
        let minute = this.formatNum(date.getMinutes());
        let second = this.formatNum(date.getSeconds());
        let formatDate = `${year}-${month}-${day}`;
        let formatTime = `${hour}:${minute}:${second}`;
        if (type === 1) {
            return formatDate;
        } else if (type === 2) {
            return formatTime;
        } else if (type === 3) {
            return formatDate + ' 00:00:00';
        } else if (type === 4) {
            return `${year}${month}${day}`;
        } else if (type === 5) {
            return [year, month, day, hour, minute, second];
        } else if (type === 6) {
            return `${formatDate} ${hour}:00:00`;
        } else {
            return `${formatDate} ${formatTime}`;
        }
    }
    // 获取格式化数字(两位)
    formatNum(num) {
        if (num < 10) {
            return '0' + num;
        }
        return num + '';
    }

    // 获取时间段(天)
    getTimeRang(days = 1, timeStamp) {
        const DAY = this.DAY;
        let endStamp = (timeStamp || new Date().getTime()) + DAY;
        let staStamp = endStamp - days * DAY;
        let endDate = new Date(endStamp);
        let staDate = new Date(staStamp);
        let formatEndDate = this.getFormatDate(endDate, 3);
        let formatStaDate = this.getFormatDate(staDate, 3);
        return [formatStaDate, formatEndDate];
    }

    // 获取上一个月时间
    getPrevMonth(monthStr, symbol = '-') {
        monthStr = monthStr.slice(0, 7);
        monthStr += '-01';
        let date = new Date(monthStr.replace(/\-/g, '/'));
        let timeArr = this.getFormatDate(date, 5);
        let year = timeArr[0];
        let month = timeArr[1] - 1;
        if (month <= 0) {
            month = 12;
            --year;
        } else if (month < 10) {
            month = '0' + month;
        }
        return `${year}${symbol}${month}`;
    }
    // 获取下一个月时间
    getNextMonth(monthStr, symbol = '-') {
        monthStr = monthStr.slice(0, 7);
        monthStr += '-01';
        let date = new Date(monthStr.replace(/\-/g, '/'));
        let timeArr = this.getFormatDate(date, 5);
        let year = timeArr[0];
        let month = +timeArr[1] + 1;
        if (month > 12) {
            month = '01';
            ++year;
        } else if (month < 10) {
            month = '0' + month;
        }
        return `${year}${symbol}${month}`;
    }

    // 获取范围内值对应颜色
    getRangColor({ value, rang = [], colors = this.colors, defaultColor = 'rgb(170,170,170)' }) {
        if (rang.length <= 1 || colors.length <= 0) return defaultColor;
        if (value <= rang[0]) return defaultColor;
        for (let i = 1, j = i - 1; i < rang.length || j < colors.length; i++, j++) {
            if (value <= rang[i]) {
                return colors[j];
            }
        }
        return defaultColor;
    }

    // 获取缓存
    getStorage(key) {
        let str = window.localStorage.getItem(key);
        let data;
        try {
            data = JSON.parse(str);
        } catch (e) {
            return str;
        }
        return data;
    }

    // 获取缓存对象值
    getStorageVal(keyStr) {
        let keys = keyStr.split('.');
        let data = this.getStorage(keys[0]);
        for (let i = 1; i < keys.length; i++) {
            if (data) {
                data = data[keys[i]];
            } else {
                break;
            }
        }
        return data;
    }

    // 设置缓存
    setStorage (key, value) {
        const strV = JSON.stringify(value)
        window.localStorage.setItem(key, strV)
    }

    // 合并默认数据对象(同属性不合并)
    mergeObj(target, source) {
        for (let key in source) {
            if (source[key] instanceof Array) {
                if (source[key].length <= 0 || !(target[key] instanceof Array)) { continue }
                for (let item of target[key]) {
                    this.mergeObj(item, source[key][0]);
                }
            } else if (typeof source[key] === 'object') {
                let obj = this.mergeObj(target[key] || {}, source[key]);
                if (!target[key]) target[key] = obj;
            } else {
                if (target[key] || target[key] === 0 || target[key] === false) continue;
                target[key] = source[key];
            }
        }
        return target;
    }

    // 简易节流
    throttle(func, delay) {
        let start = new Date();
        return function () {
            let now = new Date();
            if (now - start >= delay) {
                func.apply(this, arguments);
                start = now;
            }
        };
    }

    // 获取时间戳加随机数作为ID
    getTimeStampId() {
        let timeStamp = new Date().getTime();
        let random = parseInt(Math.random() * 1000);
        return timeStamp * 1000 + random;
    }

    // 转换比例大小(某些地方框架转换不到)
    toRealPx(px) {
        return (px / 75) * (window.innerWidth / 10); // px
    }
    // 转换比例大小(某些地方框架转换不到)
    toRealRem(px) {
        return px / 75; // rem
    }

    // 根据key获取对象值
    getValue(data, keys = []) {
        if (keys.length <= 0) return undefined;
        for (let key of keys) {
            if (data) {
                data = data[key];
            } else {
                break;
            }
        }
        return data;
    }
    // 正序
    sortArr(list, keys = []) {
    // list = ['9',0,'0','6',15,undefined,1,0,'',null,'2'];
        if (list.length <= 0) return 0;
        let invalidNum = 0;
        for (let i = 1; i < list.length; i++) {
            for (let j = i; j > 0; j--) {
                let a = this.getValue(list[j - 1], keys);
                let b = this.getValue(list[j], keys);
                if (a !== 0 && !a && (b || b !== 0)) {
                    [list[j - 1], list[j]] = [list[j], list[j - 1]];
                    continue;
                }
                a = +a;
                if (b !== 0 && !b) {
                    invalidNum++;
                    break;
                }
                b = +b;
                if (a > b) {
                    [list[j - 1], list[j]] = [list[j], list[j - 1]];
                }
            }
        }
        let first = this.getValue(list[0], keys);
        if (first !== 0 && !first) return 0;
        return list.length - invalidNum;
    }
    // 倒序
    sortArrReverse(list, keys = []) {
        if (list.length <= 0) return 0;
        let invalidNum = 0;
        for (let i = 1; i < list.length; i++) {
            for (let j = i; j > 0; j--) {
                let a = this.getValue(list[j - 1], keys);
                let b = this.getValue(list[j], keys);
                if (a !== 0 && !a && (b || b !== 0)) {
                    [list[j - 1], list[j]] = [list[j], list[j - 1]];
                    continue;
                }
                a = +a;
                if (b !== 0 && !b) {
                    invalidNum++;
                    break;
                }
                b = +b;
                if (a < b) {
                    [list[j - 1], list[j]] = [list[j], list[j - 1]];
                }
            }
        }
        let first = this.getValue(list[0], keys);
        if (first !== 0 && !first) return 0;
        return list.length - invalidNum;
    }

    MsgError(msg) {
        let MyError = function (msg) {
            this.name = 'MsgError';
            this.message = msg || '系统错误';
            this.stack = new Error().stack;
        };
        MyError.prototype = Object.create(Error.prototype);
        MyError.prototype.constructor = MyError;
        return new MyError(msg);
    }

    // 加载提示(禁止操作)
    loading(message = '加载中...') {
        Toast({
            type: 'loading',
            message: message,
            forbidClick: true,
            duration: 0,
        });
    }

    // 获取时间戳加随机数作为ID
    getTimeStampId16 () {
        const timeStamp = new Date().getTime()
        const random = Math.random() + ''
        return `${timeStamp}-${random.substr(2, 16)}`
    }

    // base64转file
    base64ToFile = (dataurl, filename) => {
        const arr = dataurl.split(',')
        const mime = arr[0].match(/:(.*?);/)[1]
        const bstr = atob(arr[1])
        let n = bstr.length
        const u8arr = new Uint8Array(n)
        while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
        }
        // 转换成file对象
        return new File([u8arr], filename, { type: mime })
        // 转换成成blob对象
        // return new Blob([u8arr],{type:mime});
    }
}

export default new Common();
